<!-- Hack to ensure mat chip styling is imported -->
<button mat-flat-button
  [disableRipple]="!clickable"
  (click)="itemClick.emit()"
  [style.color]="invertColor(color)"
  [style.background-color]="color"
  [ngClass]="{ 'highlighted': highlighted }"
  class="ellipsis mat-elevation-z2"
  style="max-width: 100%; width: 100%; border-radius: 25px;"
>
  <div class="ellipsis" style="max-width: 100%; width: 100%; overflow: hidden">
    <mat-icon>{{icon}}</mat-icon>&nbsp;{{label}}
  </div>
</button>

